import {
  FileDocumentExtension,
  FileExtension,
  FileImageExtension,
  FileMiscellaneous,
} from '../models';

const allowedExtensions = new Set<string>([
  ...Object.values(FileImageExtension),
  ...Object.values(FileDocumentExtension),
  ...Object.values(FileMiscellaneous),
]);

export function isImage(fileExtension: string | undefined): fileExtension is FileImageExtension {
  return (Object.values(FileImageExtension) as readonly string[]).includes(
    fileExtension?.toLowerCase() as FileImageExtension
  );
}

export function isPdf(
  fileExtension: string | undefined
): fileExtension is FileDocumentExtension.PDF {
  return fileExtension?.toLowerCase() === FileDocumentExtension.PDF.toLowerCase();
}

export function getFileExtensionFromPath(path: string): FileExtension | undefined {
  if (!path) return undefined;
  const lastDot = path.lastIndexOf('.');
  if (lastDot === -1 || lastDot === path.length - 1) return undefined;
  const ext = path.substring(lastDot + 1).toLowerCase();

  return allowedExtensions.has(ext) ? (ext as FileExtension) : undefined;
}

export function getBaseFileNameFromKnownExtensions(fileName: string): string {
  const lastDotIdx = fileName.lastIndexOf('.');

  let baseName = fileName;
  if (lastDotIdx > 0) {
    const candidate = fileName.substring(lastDotIdx + 1).toLowerCase();
    if (allowedExtensions.has(candidate)) {
      baseName = fileName.substring(0, lastDotIdx);
    }
  }

  return baseName;
}
